var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "720px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": (val) => _vm.$emit("update:visible", val),
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.localFormData,
                rules: _vm.formRules,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "轮播标题", prop: "title" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入轮播标题",
                      maxlength: "100",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.localFormData.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "title", $$v)
                      },
                      expression: "localFormData.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "跳转类型", prop: "jump_type" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleJumpTypeChange },
                      model: {
                        value: _vm.localFormData.jump_type,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "jump_type", $$v)
                        },
                        expression: "localFormData.jump_type",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "link" } }, [
                        _vm._v("指定链接"),
                      ]),
                      _c("el-radio", { attrs: { label: "act" } }, [
                        _vm._v("平台活动"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.localFormData.jump_type === "link"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "链接类型", prop: "url_type" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择链接类型" },
                              on: { change: _vm.handleLinkTypeChange },
                              model: {
                                value: _vm.localFormData.url_type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.localFormData, "url_type", $$v)
                                },
                                expression: "localFormData.url_type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "无链接", value: "none" },
                              }),
                              _c("el-option", {
                                attrs: { label: "站内链接", value: "inner" },
                              }),
                              _c("el-option", {
                                attrs: { label: "站外链接", value: "outer" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.localFormData.url_type === "outer"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "打开方式", prop: "open_type" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择打开方式" },
                                  model: {
                                    value: _vm.localFormData.open_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.localFormData,
                                        "open_type",
                                        $$v
                                      )
                                    },
                                    expression: "localFormData.open_type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "新页签",
                                      value: "new_tab",
                                    },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "内嵌", value: "embed" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.localFormData.url_type === "inner" ||
                      _vm.localFormData.url_type === "outer"
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "详情链接", prop: "jump_url" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入详情链接",
                                  maxlength: "255",
                                  "show-word-limit": "",
                                },
                                model: {
                                  value: _vm.localFormData.jump_url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localFormData, "jump_url", $$v)
                                  },
                                  expression: "localFormData.jump_url",
                                },
                              }),
                              _vm.localFormData.url_type === "inner"
                                ? _c("div", { staticClass: "link-tip" }, [
                                    _vm._v("站内链接以/开头"),
                                  ])
                                : _vm.localFormData.url_type === "outer"
                                ? _c("div", { staticClass: "link-tip" }, [
                                    _vm._v("站外链接以http或https开头"),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm.localFormData.jump_type === "act"
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "平台活动", prop: "act_id" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                gap: "10px",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("LanguageInputEcho", {
                                attrs: {
                                  obj: _vm.localFormData.act_title || {},
                                  size: "mini",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    color: "#909399",
                                    "font-size": "12px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "(活动ID：" +
                                      _vm._s(_vm.localFormData.act_id) +
                                      ")"
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      _vm.activityDialogVisible = true
                                    },
                                  },
                                },
                                [_vm._v("选择")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "160px" },
                    attrs: {
                      controls: false,
                      min: 0,
                      step: 1,
                      placeholder: "请输入排序序号",
                    },
                    model: {
                      value: _vm.localFormData.sort,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "sort", $$v)
                      },
                      expression: "localFormData.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "展示时间", prop: "isPermanent" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      on: { change: _vm.handleShowTimeChange },
                      model: {
                        value: _vm.localFormData.isPermanent,
                        callback: function ($$v) {
                          _vm.$set(_vm.localFormData, "isPermanent", $$v)
                        },
                        expression: "localFormData.isPermanent",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: true } }, [
                        _vm._v("永久有效"),
                      ]),
                      _c("el-radio", { attrs: { label: false } }, [
                        _vm._v("指定时间"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.localFormData.isPermanent
                ? _c(
                    "div",
                    { staticClass: "time-range" },
                    [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "0" },
                          attrs: { gutter: 20 },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "开始时间",
                                    prop: "start_at",
                                  },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "请选择开始时间",
                                      "picker-options": _vm.startPickerOptions,
                                    },
                                    on: { change: _vm.handleTimeChange },
                                    model: {
                                      value: _vm.localFormData.start_at,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "start_at",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.start_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: "结束时间", prop: "end_at" },
                                },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "datetime",
                                      placeholder: "请选择结束时间",
                                      "picker-options": _vm.endPickerOptions,
                                    },
                                    on: { change: _vm.handleTimeChange },
                                    model: {
                                      value: _vm.localFormData.end_at,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.localFormData,
                                          "end_at",
                                          $$v
                                        )
                                      },
                                      expression: "localFormData.end_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "轮播广告图片(1张)", prop: "image_url" } },
                [
                  _c("SingleImageUpload", {
                    attrs: { tip: "支持jpg、jpeg、png格式", size: "100" },
                    model: {
                      value: _vm.localFormData.image_url,
                      callback: function ($$v) {
                        _vm.$set(_vm.localFormData, "image_url", $$v)
                      },
                      expression: "localFormData.image_url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleCancel } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.loading || _vm.dialogLoading,
              },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
      _c("ActivitySelectDialog", {
        attrs: { visible: _vm.activityDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.activityDialogVisible = $event
          },
          select: _vm.handleActivitySelect,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }